import angular from 'angular';

function EmptyItem() {
	return function (array) {
		if (!array) {
			return;
		}
		if (array[0] && array[0].id === '__empty__') {
			array.splice(0, 1);
			return array;
		} else {
			return array.filter(item => item.id !== '__empty__')
		}
	};
}

export default angular.module('filters.empty-item', [])
	.filter('emptyItem', EmptyItem)
	.name;



// WEBPACK FOOTER //
// ./project/filters/empty-item.js